<template>
  <div>
    <b-row>
      <b-col cols="12" xl="12">  
        <b-card :header="titulo">
          <b-table 
              small 
              class="data-display" 
              responsive="sm"
              :busy="tableBusy" 
              :items="pagoDatos" 
              :fields="fields">
            <div slot="table-busy" class="text-center">
              <b-spinner class="table-spinner" label="Spinning" />
            </div>              
            <template v-slot:cell(valor)="data">
              {{ formattedData(data.item) }}
            </template>
          </b-table>
        </b-card>

        <b-card header="Comprobantes" v-if="tieneComprobantes">
          <b-table 
              small 
              responsive="sm" 
              :busy="tableBusy" 
              class="registro-ordenes"
              :items="pagoComprobantes" 
              :fields="comprobantesFields">
            <div slot="table-busy" class="text-center">
              <b-spinner class="table-spinner" label="Spinning" />
            </div>              
            <template v-slot:cell(fechaRegistro)="data">
              {{ data.item.fechaRegistro | fecha }}
            </template>
            <template v-slot:cell(fechaVencimiento)="data">
              {{ data.item.fechaVencimiento | fecha }}
            </template>
            <template v-slot:cell(periodo)="data">
              {{ data.item.periodo | periodo }}
            </template>
            <template v-slot:cell(importe)="data">
              {{ data.item.importe | moneda(data.item.moneda) }}
            </template>
            <template v-slot:cell(importePago)="data">
              {{ data.item.importePago | moneda(data.item.moneda) }}
            </template>
          </b-table>
        </b-card>

        <b-card header="Cuotas" v-if="tieneCuotas">
          <b-table 
              small 
              responsive="sm" 
              :busy="tableBusy" 
              class="registro-ordenes"
              :items="pagoCuotas" 
              :fields="cuotasFields">
            <div slot="table-busy" class="text-center">
              <b-spinner class="table-spinner" label="Spinning" />
            </div>              
            <template v-slot:cell(fechaVencimiento)="data">
              <template>
                {{ data.item.fechaVencimiento | fecha }}
              </template>
            </template>
            <template v-slot:cell(importeCapital)="data">
              <template>
                {{ data.item.importeCapital | moneda }}
              </template>
            </template>
            <template v-slot:cell(importeIntereses)="data">
              <template>
                {{ data.item.importeIntereses | moneda }}
              </template>
            </template>
            <template v-slot:cell(importeInteresesResarcitorios)="data">
              <template>
                {{ data.item.importeInteresesResarcitorios | moneda }}
              </template>
            </template>
          </b-table>
        </b-card>

        <b-card header="Efectivo" v-if="pagoDocumentos.length != 0">
          <b-table 
              small 
              responsive="sm" 
              :busy="tableBusy" 
              class="registro-ordenes"
              :items="pagoDocumentos" 
              :fields="documentosFields">
            <div slot="table-busy" class="text-center">
              <b-spinner class="table-spinner" label="Spinning" />
            </div>              
            <!-- <template v-slot:cell(documentoNumero)="data">
              {{ data.item.documentoNumero }}
            </template> -->
            <template v-slot:cell(importe)="data">
              {{ data.item.importe | moneda }}
            </template>
          </b-table>
        </b-card>

        <b-card header="Cheques Propios" v-if="pagoChequesPropios.length != 0">
          <b-table 
              small 
              responsive="sm" 
              class="registro-ordenes"
              :items="pagoChequesPropios" 
              :fields="chequesPropiosFields">
            <template v-slot:cell(fechaEmision)="data">
              {{ data.item.fechaEmision | fecha }}
            </template>
            <template v-slot:cell(fechaPago)="data">
              {{ data.item.fechaPago | fecha }}
            </template>
            <template v-slot:cell(importe)="data">
              {{ data.item.importe | moneda(data.item.moneda) }}
            </template>
          </b-table>
        </b-card>

        <b-card header="Transferencias" v-if="pagoTransferenciasProveedores.length != 0">
          <b-table 
              small 
              responsive="sm" 
              class="registro-ordenes"
              :items="pagoTransferenciasProveedores" 
              :fields="transferenciasProveedoresFields">
            <template v-slot:cell(fechaCreditoDebito)="data">
              {{ data.item.fechaCreditoDebito | fecha }}
            </template>
            <template v-slot:cell(importe)="data">
              {{ data.item.importe | moneda(data.item.moneda) }}
            </template>
          </b-table>
        </b-card>

        <b-card header="VEP" v-if="pagoVeps.length != 0">
          <b-table 
              small 
              responsive="sm" 
              class="registro-ordenes"
              :items="pagoVeps" 
              :fields="transferenciasProveedoresFields">
            <template v-slot:cell(fechaCreditoDebito)="data">
              {{ data.item.fechaCreditoDebito | fecha }}
            </template>
            <template v-slot:cell(importe)="data">
              {{ data.item.importe | moneda(data.item.moneda) }}
            </template>
          </b-table>
        </b-card>

        <b-card header="Cupones" v-if="pagoTarjetasCupones.length != 0">
          <b-table 
              small 
              responsive="sm" 
              class="registro-ordenes"
              :items="pagoTarjetasCupones" 
              :fields="tarjetasCuponesFields">
            <template v-slot:cell(fechaCupon)="data">
              {{ data.item.fechaCupon | fecha }}
            </template>
            <template v-slot:cell(importe)="data">
              {{ data.item.importe | moneda(data.item.moneda) }}
            </template>
          </b-table>
        </b-card>

        <b-card header="Planes de Pago" v-if="pagoPlanesPagos.length != 0">
          <b-table 
              small 
              responsive="sm" 
              class="registro-ordenes"
              :items="pagoPlanesPagos" 
              :fields="planesPagosFields">
            <template v-slot:cell(fechaVencimientoInicial)="data">
              {{ data.item.fechaVencimientoInicial | fecha }}
            </template>
            <template v-slot:cell(importe)="data">
              {{ data.item.importe | moneda(data.item.moneda) }}
            </template>
          </b-table>
        </b-card>

        <b-card header="Retenciones" v-if="pagoRetencionesProveedores.length != 0">
          <b-table 
              small 
              responsive="sm" 
              class="registro-ordenes"
              :items="pagoRetencionesProveedores" 
              :fields="retencionesProveedoresFields">
            <template v-slot:cell(fechaComprobante)="data">
              {{ data.item.fechaComprobante | fecha }}
            </template>
            <template v-slot:cell(importe)="data">
              {{ data.item.importe | moneda(data.item.moneda) }}
            </template>
          </b-table>
        </b-card>
      </b-col>
    </b-row>

    <div class="fixed-btn">
      <div class="data-goback-btn" @click.prevent="goBack">
          <i class="fa fa-undo fa-2x" aria-hidden="true"></i>
      </div>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'pago/getField',
  mutationType: 'pago/updateField',
});

export default {
  name: 'PagoData',
  components: {
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal, 
  ],
  props: {
    impuestos: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      fields: [
        {key: 'campo'},
        {key: 'valor'},
      ],

      comprobantesFields: [
        { 
          key: 'fechaRegistro',
          label: 'Fecha'
        },
        { key: 'fechaVencimiento' },
        { 
          key: 'comprobanteTipo',
          label: 'Comprobante'
        },
        { 
          key: 'comprobanteNumero',
          label: 'Nro.Comprobante'
        },
        { 
          key: 'importe',
          class: 'text-right'
        },
        { 
          key: 'importePago',
          class: 'text-right'
        },
      ],

      cuotasFields: [
        {
          key: 'numeroCuota',
          label: 'Nro Cuota'
        },
        {
          key: 'fechaVencimiento'
        },
        {
          key: 'importeCapital',
          label: 'Capital',
          class: 'text-right'
        },
        {
          key: 'importeIntereses',
          label: 'Intereses',
          class: 'text-right'
        },
        {
          key: 'importeInteresesResarcitorios',
          label: 'Intereses Resarcit.',
          class: 'text-right'
        }
      ],

      documentosFields: [
        { 
          key: 'documentoTipo',
          label: 'Moneda'
        },
        // { 
        //   key: 'documentoNumero',
        //   label: 'Nro.Documento'
        // },
        { 
          key: 'importe',
          class: 'text-right'
        },
      ],

      chequesPropiosFields: [
        {
          key: 'fechaEmision',
          label: 'Fecha Emisión'
        },
        { key: 'fechaPago' },
        {
          key: 'bancoCuenta',
          label: 'Cuenta'
        },
        { 
          key: 'numero',
          label: 'Número',
          class: 'text-right'
        },
        { 
          key: 'importe',
          class: 'text-right'
        },
      ],

      tarjetasCuponesFields: [
        { key: 'tarjeta' },
        {
          key: 'loteNumero',
          label: 'Lote'
        },
        {
          key: 'cuponNumero',
          label: 'Nro Cupón'
        },
        { key: 'fechaCupon' },
        { 
          key: 'cuotas',
          label: 'Cuotas',
          class: 'text-right'
        },
        { 
          key: 'importe',
          class: 'text-right'
        },
      ],

      transferenciasProveedoresFields: [
        {
          key: 'fechaCreditoDebito',
          label: 'Fecha Debito'
        },
        {
          key: 'bancoCuenta',
          label: 'Cuenta'
        },
        { 
          key: 'importe',
          class: 'text-right'
        },
      ],

      retencionesProveedoresFields: [
        {
          key: 'fechaComprobante',
          label: 'Fecha'
        },
        {
          key: 'retencionTipo',
          label: 'Tipo',
        },
        {
          key: 'retencionRegimen',
          label: 'Regimen',
        },
        { 
          key: 'importe',
          class: 'text-right'
        },
      ],

      planesPagosFields: [
        {
          key: 'fechaVencimientoInicial',
          label: 'Vencim.Inicial'
        },
        {
          key: 'numero',
          label: 'Número',
        },
        {
          key: 'bancoCuenta',
          label: 'Cuenta',
        },
        { 
          key: 'cantidadCuotas',
          label: 'Cant.Cuotas',
          class: 'text-right'
        },
        { 
          key: 'importe',
          class: 'text-right'
        },
      ],

      tableBusy: false
    }
  },
  computed: {
    ...mapFields([
      'pagoDatos',
      'pagoComprobantes',
      'pagoCuotas',
      'pagoDocumentos',
      'pagoChequesPropios',
      'pagoTarjetasCupones',
      'pagoTransferenciasProveedores',
      'pagoRetencionesProveedores',
      'pagoVeps',
      'pagoPlanesPagos'
    ]),
    titulo() {
      if ((/true/i).test(this.impuestos)) {
        return 'Información del Pago';
      }
      return 'Información de la Orden de Pago';
    },
    tieneComprobantes() {
      return this.pagoComprobantes && this.pagoComprobantes.length > 0;
    },
    tieneCuotas() {
      return this.pagoCuotas && this.pagoCuotas.length > 0;
    }
  },
  created() {
    let pagoId = this.$route.params.id;

    let params = {
      impuestos: this.impuestos,
      pagoId
    }

    if ((/true/i).test(this.impuestos)) {
      this.comprobantesFields = [
        {
          key: 'fechaRegistro',
          label: 'Fecha'
        },
        { 
          key: 'proveedor',
          label: 'Impuesto'   
        },
        { key: 'periodo' },
        { 
          key: 'importe',
          class: 'text-right'
        },
        { 
          key: 'importePago',
          class: 'text-right'
        },
      ]
    }

    this.tableBusy = true;
    this.$store.dispatch('pago/getDatos', params)
      .then(() => this.tableBusy = false)
      .catch(error => this.showErrorMsj(error));
  },  
  methods: {
    goBack() {
      this.$router.go(-1);
    },
  }
}
</script>
